import {
  BedragValidation,
  DateValidation,
  IsRequiredValidation,
  HasMaxLengthValidation,
  HasMinimalAmountValidation
} from "@generation/form";
import { translate } from "../Locales/translate";
import { DateNotInFutureValidation } from "./date-not-in-future";

export const IsRequiredValidationFactory = () =>
  new IsRequiredValidation(false, (label?: string) =>
    translate("IsRequiredValidationFactoryValidationText", { label: label || "" })
  );

export const IsBedragValidationFactory = () =>
  new BedragValidation(false, (label?: string) =>
    translate("IsBedragValidationFactoryValidationText", { label: label || "" })
  );

export const DateValidationFactory = () =>
  new DateValidation(true, (label?: string) =>
    translate("DateValidationFactoryValidationText", { label: label || "" })
  );

export const DateNotInFutureValidationFactory = () =>
  new DateNotInFutureValidation(true, (label?: string) =>
    translate("DateNotInFutureValidationFactoryText", { label: label || "" })
  );

export const HasMaxLengthValidationFactory = (maxLength: number, limitMaxLengthOnInputs: boolean) =>
  new HasMaxLengthValidation(
    maxLength,
    (label?: string) =>
      translate("HasMaxLengthValidationText", { label: label || "", maxLength: maxLength.toString() }),
    limitMaxLengthOnInputs
  );

export const MinimalAmountValidationFactory = (minimalAmount: number, label?: string, errorText?: string) =>
  new HasMinimalAmountValidation(
    minimalAmount,
    () =>
      errorText ??
      `U heeft het invulveld '${label}' niet juist ingevuld. Het bedrag moet minimaal ${minimalAmount} of hoger zijn.`
  );
